/**
 * @file retrieves file name, extension, and embedded url from a file
 */
const getExtension = function(file: File): string {
  if (file.name) {
    const filename = file.name
    const extensionStartIndex = (Math.max(0, filename.lastIndexOf('.')) || Infinity) + 1
    let possibleExtension = filename.substr(extensionStartIndex)
    if (possibleExtension == '') {
      return possibleExtension
    }
    // remove query string
    possibleExtension = possibleExtension.replace(/\?.*$/, '')
    // if there are special characters, this is not an extension
    if (/[^a-zA-Z0-9]/.exec(possibleExtension)) {
      return ''
    } else {
      return possibleExtension.toLowerCase()
    }
  } else if (file.type) {
    // return png for image/png
    const [mimeType, charset] = file.type.split(';')
    const [mimeTypeWithoutPlus, _] = mimeType.split('+')
    const [mimeCategory, possibleExtension] = mimeType.split('/')
    if (possibleExtension) {
      return possibleExtension.toLowerCase()
    } else {
      return ''
    }
  } else {
    return ''
  }
}

const getName = function(file: File): string {
  const ext = getExtension(file)
  if (file.name) {
    const filename = file.name
    const splits = filename.split('.')
    const extension = splits.pop()
    let baseFilename = splits.join('_')
    // cleanup special characters. They create problems
    baseFilename = baseFilename.replace(/[^a-zA-Z0-9_]/g, '_')
    // limit length
    baseFilename = baseFilename.substr(0, 100)

    if (ext) {
      return [baseFilename, ext].join('.')
    } else {
      return baseFilename
    }
  } else if (ext) {
    return `file.${ext}`
  } else {
    return 'file'
  }
}

interface UrlHash {
  url: string
}

const getEmbeddedUrl = function(file: File): Promise<UrlHash> {
  return new Promise((resolve, reject) => {
    const extension = getExtension(file)
    if (/gdoc|gsheet|glink|gform|gmap|gmaps|gslides|gdraw|url|htm|html|webloc|mht|mhtml/.exec(extension)) {
      let matches
      const reader = new FileReader()
      reader.onload = () => {
        const text: string = typeof reader.result !== 'string' ? '' : reader.result
        if (
          text !== '' &&
          (extension === 'gdoc' ||
            extension === 'gsheet' ||
            extension === 'glink' ||
            extension === 'gform' ||
            extension === 'gmap' ||
            extension === 'gmaps' ||
            extension === 'gslides' ||
            extension === 'gdraw')
        ) {
          const hash = JSON.parse(text)
          resolve({ url: hash.url })
        } else if (extension === 'url' && (matches = /URL=(.*)/.exec(text))) {
          resolve({ url: matches[1] })
        } else if (
          (extension === 'htm' || extension === 'html') &&
          text.includes('window.googleJavaScriptRedirect') &&
          (matches = /content="0;URL='(.*)'/.exec(text))
        ) {
          resolve({ url: matches[1] })
        } else if (
          (extension === 'htm' || extension === 'html') &&
          (matches = /<!--ssavedsfromsurl=((?:d+))(.*?)s-->/.exec(text)) &&
          matches[1] !== 'http://tiddlywiki.com'
        ) {
          resolve({ url: matches[1] })
        } else if (extension === 'webloc' && (matches = /<string>(.*)<\/string>/.exec(text))) {
          resolve({ url: matches[1] })
        } else if ((extension === 'mht' || extension === 'mhtml') && (matches = /Content-Location:s(.*)/.exec(text))) {
          resolve({ url: matches[1] })
        } else {
          reject()
        }
      }
      reader.onerror = (): void => {
        reject()
      }
      reader.readAsText(file)
    } else {
      reject()
    }
  })
}

export { getExtension, getName, getEmbeddedUrl }
